import React from "react"
import {
    Box,
    Typography,
    Grid,
} from "@mui/material"
import {
    MatesTextField,
} from "@sinossi/mates-react-library"
import {
    t,
    Trans,
} from "@lingui/macro"
import { UseFormReturn } from "react-hook-form"

interface CreateCompanyFormProps extends UseFormReturn
{
}

class CreateCompanyForm extends React.Component<CreateCompanyFormProps>
{
    render()
    {
        return (
            <Box>
                <Typography variant="h6" sx={{ mb: 2 }}>
                    <Trans id="ccf-title">Dati della nuova società</Trans>
                </Typography>
                
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography sx={{ pb: 1 }}>
                            <Trans id="ccf-name-label">Nome società *</Trans>
                        </Typography>
                        <MatesTextField
                            variant="outlined"
                            label={t({
                                id: "ccf-name",
                                message: "Nome società",
                            })}
                            name="companyData.name"
                            control={this.props.control}
                            trigger={this.props.trigger}
                            formState={this.props.formState}
                        />
                    </Grid>
                    
                    <Grid item xs={12}>
                        <Typography sx={{ pb: 1 }}>
                            <Trans id="ccf-address-label">Indirizzo *</Trans>
                        </Typography>
                        <MatesTextField
                            variant="outlined"
                            label={t({
                                id: "ccf-address",
                                message: "Indirizzo",
                            })}
                            name="companyData.address"
                            control={this.props.control}
                            trigger={this.props.trigger}
                            formState={this.props.formState}
                        />
                    </Grid>
                    
                    <Grid item xs={6}>
                        <Typography sx={{ pb: 1 }}>
                            <Trans id="ccf-city-label">Città *</Trans>
                        </Typography>
                        <MatesTextField
                            variant="outlined"
                            label={t({
                                id: "ccf-city",
                                message: "Città",
                            })}
                            name="companyData.city"
                            control={this.props.control}
                            trigger={this.props.trigger}
                            formState={this.props.formState}
                        />
                    </Grid>
                    
                    <Grid item xs={6}>
                        <Typography sx={{ pb: 1 }}>
                            <Trans id="ccf-province-label">Provincia *</Trans>
                        </Typography>
                        <MatesTextField
                            variant="outlined"
                            label={t({
                                id: "ccf-province",
                                message: "Provincia",
                            })}
                            name="companyData.province"
                            control={this.props.control}
                            trigger={this.props.trigger}
                            formState={this.props.formState}
                        />
                    </Grid>
                    
                    <Grid item xs={6}>
                        <Typography sx={{ pb: 1 }}>
                            <Trans id="ccf-postal-code-label">CAP *</Trans>
                        </Typography>
                        <MatesTextField
                            variant="outlined"
                            label={t({
                                id: "ccf-postal-code",
                                message: "CAP",
                            })}
                            name="companyData.postalCode"
                            control={this.props.control}
                            trigger={this.props.trigger}
                            formState={this.props.formState}
                        />
                    </Grid>
                    
                    <Grid item xs={6}>
                        <Typography sx={{ pb: 1 }}>
                            <Trans id="ccf-country-label">Paese *</Trans>
                        </Typography>
                        <MatesTextField
                            variant="outlined"
                            label={t({
                                id: "ccf-country",
                                message: "Paese",
                            })}
                            name="companyData.country"
                            control={this.props.control}
                            trigger={this.props.trigger}
                            formState={this.props.formState}
                        />
                    </Grid>
                    
                    <Grid item xs={6}>
                        <Typography sx={{ pb: 1 }}>
                            <Trans id="ccf-phone-label">Telefono *</Trans>
                        </Typography>
                        <MatesTextField
                            variant="outlined"
                            label={t({
                                id: "ccf-phone",
                                message: "Telefono",
                            })}
                            name="companyData.phone"
                            control={this.props.control}
                            trigger={this.props.trigger}
                            formState={this.props.formState}
                        />
                    </Grid>
                    
                    <Grid item xs={6}>
                        <Typography sx={{ pb: 1 }}>
                            <Trans id="ccf-vat-code-label">Partita IVA *</Trans>
                        </Typography>
                        <MatesTextField
                            variant="outlined"
                            label={t({
                                id: "ccf-vat-code",
                                message: "Partita IVA",
                            })}
                            name="companyData.vatCode"
                            control={this.props.control}
                            trigger={this.props.trigger}
                            formState={this.props.formState}
                        />
                    </Grid>
                </Grid>
            </Box>
        )
    }
}

export default CreateCompanyForm